var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibilityOff = function SvgVisibilityOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "visibility_off_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#visibility_off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.1 13.3-1.45-1.45q.275-1.325-.687-2.262T11.65 8.85L10.2 7.4A4.2 4.2 0 0 1 12 7q1.875 0 3.188 1.313Q16.5 9.625 16.5 11.5q0 .475-.1.925t-.3.875m3.2 3.15-1.45-1.4q.95-.724 1.7-1.612T20.8 11.5a9.77 9.77 0 0 0-3.613-4.012A9.55 9.55 0 0 0 12 6q-.725 0-1.412.1-.688.1-1.388.3L7.65 4.85A11.51 11.51 0 0 1 12 4q3.424 0 6.262 1.8t4.338 4.85a1.9 1.9 0 0 1 .2.85q0 .225-.038.438a1.5 1.5 0 0 1-.137.412 10 10 0 0 1-1.4 2.263A10.9 10.9 0 0 1 19.3 16.45M12 19q-3.35 0-6.125-1.812A13 13 0 0 1 1.5 12.425a1.6 1.6 0 0 1-.187-.437 2 2 0 0 1-.063-.488q0-.25.05-.475t.175-.45a13.6 13.6 0 0 1 1.163-1.912Q3.3 7.75 4.15 7L2.075 4.9a.97.97 0 0 1-.263-.712A.98.98 0 0 1 2.1 3.5a.95.95 0 0 1 .7-.275q.425 0 .7.275l17 17q.275.275.288.688a.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-3.5-3.45A12 12 0 0 1 12 19M5.55 8.4q-.725.65-1.325 1.425A9 9 0 0 0 3.2 11.5a9.77 9.77 0 0 0 3.613 4.013A9.54 9.54 0 0 0 12 17q.5 0 .975-.062.475-.063.975-.138l-.9-.95q-.274.075-.525.113A3.5 3.5 0 0 1 12 16q-1.875 0-3.187-1.312Q7.499 13.375 7.5 11.5q0-.274.037-.525.038-.25.113-.525z"
  }))));
};
export default SvgVisibilityOff;